import { ProgressBar } from '@pepper/ui'
import { ColumnsType } from 'antd/lib/table'
import clsx from 'clsx'
import { TopOrganicPagesDistribution, TopOrganicPagesList } from '../types'

import s from './TopOrganicPages.module.css'

export const getDistributionColumns = <
  RecordType extends TopOrganicPagesDistribution
>(): ColumnsType<RecordType> => {
  return [
    {
      title: <div className={s.title}>Page Traffic</div>,
      dataIndex: 'traffic_range',
      key: 'traffic_range',
      width: '30%',
      render: (_, value) => {
        return <div className={s.row}> {value.traffic_range.Name}</div>
      },
    },
    {
      title: <div className={s.title}>Number of Pages</div>,
      dataIndex: 'pages',
      key: 'pages',
      width: '25%',
      render: (_, value) => {
        return (
          <div
            className={clsx(
              s.progressWrapper,
              s.row,
              s.centerAlign,
              s.pagesWrapper
            )}
          >
            <div className={s.textWrapper}>
              <div className={clsx(s.progressValue, s.rightAlign)}>
                {value.pages.Value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.pages.Percentage.toFixed(2)}%
              </div>
            </div>

            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.pages.Percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
    {
      title: (
        <div className={clsx(s.title, s.leftAlign)}>
          Cum. Organic Search Traffic
        </div>
      ),
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      render: (_, value) => {
        return (
          <div
            className={clsx(s.progressWrapper, s.row, s.searchTrafficWrapper)}
          >
            <div className={s.textWrapper}>
              <div className={clsx(s.progressValue, s.rightAlign)}>
                {value.traffic.Value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.traffic.Percentage.toFixed(2)}%
              </div>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.traffic.Percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
  ]
}

export const getListColumns = <
  RecordType extends TopOrganicPagesList
>(): ColumnsType<RecordType> => {
  return [
    {
      title: <div className={s.title}>Page URL</div>,
      dataIndex: 'page_path',
      key: 'page_path',
      width: '35%',
      render: (_, value) => {
        return <div className={s.row}> {value.page_path}</div>
      },
    },
    {
      title: () => <div className={s.title}>Organic Search Traffic</div>,
      dataIndex: 'search_traffic',
      key: 'search_traffic',
      width: '30%',
      render: (_, value) => {
        return (
          <div className={clsx(s.progressWrapper, s.row)}>
            <div className={s.textWrapper}>
              <div className={s.progressValue}>
                {value.search_traffic.value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.search_traffic.percentage.toFixed(2)}%
              </div>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.search_traffic.percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
    {
      title: <div className={s.title}>Total Page Traffic</div>,
      dataIndex: 'total_traffic',
      key: 'total_traffic',
      width: '30%',
      render: (_, value) => {
        return (
          <div className={clsx(s.progressWrapper, s.row)}>
            <div className={s.textWrapper}>
              <div className={s.progressValue}>
                {value.total_traffic.value.toLocaleString()}
              </div>
              <div className={clsx(s.percent, s.rightAlign)}>
                {value.total_traffic.percentage.toFixed(2)}%
              </div>
            </div>
            <ProgressBar
              size="small"
              className={s.progressBar}
              percent={value.total_traffic.percentage}
              strokeColor="rgba(163, 153, 255, 1)"
              trailColor="rgba(233, 236, 239, 1)"
            />
          </div>
        )
      },
    },
    {
      title: <div className={clsx(s.title, s.rightAlign)}>Visitors</div>,
      dataIndex: 'visitors',
      key: 'visitors',
      width: '25%',
      render: (_, value) => {
        return (
          <div className={clsx(s.row, s.rightAlign)}>
            {' '}
            {value.visitors.toLocaleString()}
          </div>
        )
      },
    },
  ]
}
